import calculateSetPrice from '../../_flux/helper/calculate_set_price';

export const getPriceForAll = products => products.reduce(
    (sum, product) => sum + calculateSetPrice(product.qty, product.price, product),
    0
);
